module.exports = __webpack_public_path__ + "static/img/qualifications.9e709e1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qualifications.jpeg
// module id = 547w
// module chunks = 7